import { render } from "./BankAccountOwnerOverview.vue?vue&type=template&id=e4dd52a8&scoped=true"
import script from "./BankAccountOwnerOverview.vue?vue&type=script&lang=js"
export * from "./BankAccountOwnerOverview.vue?vue&type=script&lang=js"

import "./BankAccountOwnerOverview.vue?vue&type=style&index=0&id=e4dd52a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4dd52a8"]])

export default __exports__